import "../App.css";
import Footer from "../components/Footer";
import Header from "../components/sections/Header";
import Objectives from "../components/sections/Objectives";
import Rational from "../components/sections/Rational";
import CourseContent from "../components/sections/CourseContent";
import EligibilityFaculty from "../components/sections/EligibilityFaculty";
// import BenefitCollaborators from "../components/sections/BenefitCollaborators";
import Fees from "../components/sections/Fees";
import NavBar from "../components/NavBar";
import Collaborators from "../components/sections/Collaborators";
import OtherBenefit from "../components/sections/OtherBenefit";
import Lecturers from "../components/sections/Lecturers";
import React from "react";
import ContactUs from "../components/sections/ContactUs";
import PreAndPostTestGuidelines from '../components/sections/PreAndPostTestGuidelines';

const Home = () => {
  return (
    <div className="">
      <NavBar />
      <Header />
      <Rational />
      <Objectives />
      <CourseContent />
      <PreAndPostTestGuidelines />
      <EligibilityFaculty />
      <Fees />
      <Collaborators />
      <OtherBenefit />
      <Lecturers />
      <ContactUs />
      <Footer />
    </div>
  );
};

export default Home;
